import React, { Fragment } from 'react';
import classnames from 'classnames';

import { presetTags, } from '../shared/models/product';

const { entries } = Object;

export default function ProductTagsDisplay(props) {
  const { product, productTags = [], itemClassName, } = props;
  const allTags = [...entries(presetTags).map(([k, v]) => ({ id: k, ...v, })), ...productTags];

  return (
    <Fragment>
      {
        product?.productTagIds?.map((productTagId) => {
          const tag = allTags.find(_ => _.id === productTagId);
          const { label, color } = tag || {};
          return tag != null && (
            <div className={classnames(itemClassName, 'badge', `badge-${color}`)}>
              {label}
            </div>
          );
        })
      }
    </Fragment>
  );
};

